module.exports = __webpack_public_path__ + "south-africa.ac7afddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/south-africa.png
// module id = 1500
// module chunks = 0